import React from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";

import { AuthProvider } from "./contexts/AuthContext";

import ProtectedRoute from "./components/ProtectedRoute";
import AccountLayout from "./components/layout/AccountLayout";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import Start from "./pages/admin/Start";
import Work from "./pages/admin/Work";
import Finance from "./pages/admin/Finance";
import Calendar from "./pages/admin/Calendar";
import Sport from "./pages/admin/Sport";
import Components from "./pages/admin/Components";
import Website from "./pages/Website";

function App() {
  return (
    <AuthProvider>
      <div
        id="kt_docs_toast_stack_container"
        className="toast-container position-fixed bottom-0 end-0 p-3 z-index-9999"
      ></div>
      <BrowserRouter basename={"/"}>
        <Routes>
          <Route path="/" element={<Website />} />
          <Route path="/account/login" element={<Login />} />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <AccountLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="work" replace />} />
            <Route path="start" element={<Start />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="work" element={<Work />} />
            <Route path="finance" element={<Finance />} />
            <Route path="calendar" element={<Calendar />} />
            <Route path="sport" element={<Sport />} />
            <Route path="components" element={<Components />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
